import {
  AppOfferListItem,
  isAppOffer,
  isAppOfferGroup,
  isAppPersonalizedOfferGroup,
} from 'state/loyalty/types';

export function parseOfferListPosition(offerListPositionParam: unknown): number | null {
  const raw = Array.isArray(offerListPositionParam)
    ? offerListPositionParam[0]
    : offerListPositionParam;
  const parsed = typeof raw === 'number' ? raw : typeof raw === 'string' ? Number(raw) : NaN;

  if (Number.isInteger(parsed) && parsed >= 1) {
    return parsed;
  }

  return null;
}

/**
 * Amplitude's SDK treats `null` and `undefined` as invalid event properties and
 * drops the key before the inspector or ingestion sees it. Empty string is kept.
 */
export function toAmplitudeOfferListPosition(position: number | null): number | '' {
  return position ?? '';
}

export type OfferListPositionTarget =
  | { kind: 'offer'; loyaltyEngineId: string }
  | { kind: 'group'; cmsId: string; id?: string };

export function findOfferListItemIndex(
  items: AppOfferListItem[],
  target: OfferListPositionTarget
): number {
  return items.findIndex(item => {
    if (target.kind === 'offer') {
      return isAppOffer(item) && item.loyaltyEngineId === target.loyaltyEngineId;
    }

    if (target.id) {
      return isAppPersonalizedOfferGroup(item) && String(item.id) === String(target.id);
    }

    return (
      (isAppOfferGroup(item) || isAppPersonalizedOfferGroup(item)) &&
      String(item.cmsId) === String(target.cmsId)
    );
  });
}

export function offerListPositionParams(index: number): { olp: string } | Record<string, never> {
  return index >= 0 ? { olp: String(index + 1) } : {};
}
